import type { MemberWorkoutPlan, WorkoutPlanWithSchedule } from '../types/dataModel';
import type { WorkoutSession } from '../types/dataModel';

/**
 * localStorage cache key for member dashboard payload (useCachedData + CacheService).
 * Bump suffix when cached shape or semantics change.
 */
export function memberDashboardCacheKey(memberId: string): string {
  return `dashboard_v4_${memberId}`;
}

/**
 * Derives the same version signal as WorkoutService.getMemberDashboardVersion / fetchDashboardData
 * so caches written without _version (e.g. WorkoutDetailsPage) still participate in version-first checks.
 */
export function dashboardDataVersionFromPayload(d: {
  _version?: string | null;
  plans?: (MemberWorkoutPlan & { workoutPlan: WorkoutPlanWithSchedule })[];
  sessions?: (WorkoutSession & { workout?: unknown })[];
}): string | null {
  if (d._version) return d._version;
  const planMax = Math.max(
    0,
    ...(d.plans || []).map((p) => (p.updatedAt ? new Date(p.updatedAt).getTime() : 0))
  );
  const sessionMax = Math.max(
    0,
    ...(d.sessions || []).map((s) => (s.updatedAt ? new Date(s.updatedAt).getTime() : 0))
  );
  const maxTs = Math.max(planMax, sessionMax);
  return maxTs > 0 ? new Date(maxTs).toISOString() : null;
}
